import React from "react";
import { BsSearch } from "react-icons/bs";
import { GoPlus } from "react-icons/go";
const SectionHeader = ({ title, objective }) => {
  return (
    <div className="flex justify-between items-start mt-5">
      <div>
        <h3 className="text-2xl font-bold text-black mt-4">{title}</h3>
        <p className="font-normal text-gray-700">{objective}</p>
      </div>
    </div>
  );
};

export default SectionHeader;
